// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orc-page {
    background: #f5f6fa;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.orc-body {
    padding: 24px;
    flex: 1 1;
}


/* ---- Card branco (conteúdo) ---- */
.orc-card {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 1px 8px rgba(0,0,0,0.07);
}

/* ---- Sub-navbar (fora do card, botões pill) ---- */
.orc-subnav {
    display: flex;
    gap: 4px;
    background: #e2e8f0;
    border-radius: 8px;
    padding: 3px;
    margin-bottom: 14px;
    width: fit-content;
}

.orc-subnav-btn {
    padding: 8px 20px;
    border: none;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    color: #64748b;
    background: transparent;
    transition: all 0.15s;
    white-space: nowrap;
}

.orc-subnav-btn:hover { color: #1e293b; background: rgba(255,255,255,0.6); }
.orc-subnav-btn.active { background: #fff; color: #3182ce; box-shadow: 0 1px 4px rgba(0,0,0,0.1); }


.orc-ano-btn {
    padding: 6px 18px;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    color: #64748b;
    background: #fff;
    transition: all 0.15s;
    white-space: nowrap;
}

.orc-ano-btn:hover { color: #1e293b; border-color: #94a3b8; }
.orc-ano-btn.active { background: #3182ce; color: #fff; border-color: #3182ce; }

.orc-tab-content { padding: 20px; }

/* ---- Toolbar dos tabs ---- */
.tab-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    flex-wrap: wrap;
    gap: 8px;
}

.tab-toolbar-right {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
}

.btn-novo-item {
    background: #3182ce;
    color: #fff;
    border: none;
    border-radius: 6px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}
.btn-novo-item:hover { background: #2b6cb0; }

.btn-secondary-action {
    background: #fff;
    color: #374151;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 8px 14px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}
.btn-secondary-action:hover:not(:disabled) { background: #f3f4f6; }
.btn-secondary-action:disabled { opacity: 0.6; cursor: default; }

.btn-import {
    background: #fff;
    border: 1px solid #d1d5db;
    color: #374151;
    border-radius: 6px;
    padding: 8px 14px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}
.btn-import:hover:not(:disabled) { background: #f3f4f6; }
.btn-import:disabled { opacity: 0.6; cursor: not-allowed; }

.btn-template {
    background: #fff;
    border: 1px solid #d1d5db;
    color: #374151;
    border-radius: 6px;
    padding: 8px 14px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    text-decoration: none;
}
.btn-template:hover { background: #f3f4f6; }

.import-msg {
    padding: 8px 14px;
    border-radius: 6px;
    font-size: 13px;
    margin-bottom: 12px;
}
.import-ok  { background: #d1fae5; color: #065f46; }
.import-err { background: #fee2e2; color: #dc2626; }

/* ---- Painéis — linha única full width ---- */
.orc-paineis {
    display: flex;
    flex-direction: row;
    gap: 10px;
    margin-bottom: 10px;
    width: 100%;
}

.orc-painel {
    flex: 1 1;
    background: #fff;
    border-radius: 8px;
    padding: 10px 14px;
    cursor: pointer;
    border: 2px solid transparent;
    box-shadow: 0 1px 4px rgba(0,0,0,0.06);
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: box-shadow 0.15s, border-color 0.15s;
}
.orc-painel:hover { box-shadow: 0 3px 10px rgba(0,0,0,0.12); }
.orc-painel.painel-active { border-color: currentColor; }

.painel-num  { font-size: 22px; font-weight: 700; line-height: 1; }
.painel-label{ font-size: 10px; font-weight: 600; margin-top: 3px; text-transform: uppercase; letter-spacing: 0.4px; text-align: center; }

.painel-todos     { color: #6366f1; }
.painel-orcamento { color: #f59e0b; }
.painel-producao  { color: #3b82f6; }
.painel-enviado   { color: #8b5cf6; }
.painel-faturar   { color: #10b981; }

/* ---- Painel Entregas Hoje ---- */
.orc-hoje-panel {
    width: 100%;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.06);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border: 1px solid #e2e8f0;
    margin-bottom: 12px;
}

.orc-hoje-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px 14px;
    border-bottom: 1px solid #f0f4f8;
    font-size: 12px;
    font-weight: 700;
    color: #1e293b;
    background: #f8fafc;
    flex-shrink: 0;
}

.orc-hoje-header-right {
    display: flex;
    align-items: center;
    gap: 8px;
}

.orc-hoje-gestor-sel {
    font-size: 11px;
    font-weight: 500;
    color: #475569;
    border: 1px solid #e2e8f0;
    border-radius: 5px;
    padding: 3px 8px;
    background: #fff;
    cursor: pointer;
    outline: none;
}
.orc-hoje-gestor-sel:focus { border-color: #3182ce; }

.orc-hoje-count {
    background: #fee2e2;
    color: #dc2626;
    font-size: 11px;
    font-weight: 700;
    padding: 1px 7px;
    border-radius: 10px;
}

.orc-hoje-list {
    overflow-y: auto;
    max-height: 136px;
    background: #fff;
}
.orc-hoje-list::-webkit-scrollbar { width: 4px; }
.orc-hoje-list::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }

/* 3 colunas */
.orc-hoje-3col {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    max-height: 140px;
}
.orc-hoje-3col .orc-hoje-item { border-right: 1px solid #f0f4f8; }
.orc-hoje-3col .orc-hoje-item:nth-child(3n) { border-right: none; }

.orc-hoje-empty {
    padding: 14px;
    text-align: center;
    color: #94a3b8;
    font-size: 12px;
    grid-column: 1 / -1;
}

.orc-hoje-item {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 1px 8px;
    border-bottom: 1px solid #f3f4f6;
    cursor: pointer;
    transition: background 0.1s;
    line-height: 1.2;
    font-size: 11px;
    transform: scale(0.82);
    transform-origin: left center;
    color: #333;
}
.orc-hoje-item:hover { background: #f0f4ff; }

.orc-hoje-id { font-weight: 600; color: #94a3b8; flex-shrink: 0; min-width: 38px; white-space: nowrap; }
.orc-hoje-cliente { font-weight: 600; color: #1e293b; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex-shrink: 0; max-width: 38%; }
.orc-hoje-sep { color: #d1d5db; flex-shrink: 0; }
.orc-hoje-proj { color: #64748b; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex: 1 1; min-width: 0; }

/* ---- Filtro por ano — sempre por baixo do subnav ---- */
.orc-ano-filter {
    display: flex;
    gap: 6px;
    margin-bottom: 14px;
    flex-wrap: wrap;
}

/* ---- Filtros ---- */
.orc-filtros {
    display: flex;
    gap: 8px;
    margin-bottom: 14px;
    flex-wrap: wrap;
    align-items: center;
}

.orc-input-search {
    flex: 1 1; min-width: 0; width: 100%;
    padding: 10px 14px;
    height: 40px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 14px;
    background: #fff;
    box-sizing: border-box;
}
.orc-input-search:focus {
    outline: none;
    border-color: #3182ce;
    box-shadow: 0 0 0 2px rgba(49, 130, 206, 0.15);
}

.orc-select, .orc-input-date {
    padding: 10px 14px;
    height: 40px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 14px;
    background: #fff;
    box-sizing: border-box;
}
.orc-select:focus, .orc-input-date:focus {
    outline: none;
    border-color: #3182ce;
    box-shadow: 0 0 0 2px rgba(49, 130, 206, 0.15);
}

.orc-select { min-width: 130px; }

.btn-limpar {
    padding: 8px 12px;
    border: 1px solid #dde1e7;
    border-radius: 6px;
    background: #fff;
    font-size: 13px;
    cursor: pointer;
    color: #666;
}
.btn-limpar:hover { background: #f3f4f6; }

.btn-excel-export {
    padding: 8px 12px;
    border: 1px solid #16a34a;
    border-radius: 6px;
    background: #f0fdf4;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    color: #16a34a;
    margin-left: auto;
}
.btn-excel-export:hover { background: #dcfce7; }

.orc-id-wrap {
    display: inline-flex;
    align-items: center;
    gap: 5px;
}
.btn-copy-id {
    display: none;
    background: none;
    border: 1px solid #cbd5e1;
    border-radius: 4px;
    padding: 1px 5px;
    font-size: 12px;
    cursor: pointer;
    color: #64748b;
    line-height: 1.2;
    flex-shrink: 0;
}
.btn-copy-id.copied { color: #16a34a; border-color: #86efac; }
.orc-row:hover .btn-copy-id { display: inline-flex; }
.btn-copy-id.copied { display: inline-flex; }

/* ---- Tabela ---- */
.orc-table-wrap {
    background: #fff;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    overflow: auto;
}

.orc-table { width: 100%; border-collapse: collapse; font-size: 12.5px; }
.orc-table thead tr { background: #f8fafc; }
.orc-table th { padding: 5px 8px; border-bottom: 1px solid #e5e7eb; font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.4px; color: #94a3b8; font-weight: 700; white-space: nowrap; }
.orc-table td { padding: 3px 8px; border-bottom: 1px solid #f3f4f6; vertical-align: middle; white-space: nowrap; line-height: 1.4; }
.orc-table td strong { font-weight: 600; color: #4a5568; }
.orc-row { cursor: pointer; transition: background 0.1s; }
.orc-row:hover { background: #f0f4ff; }

.orc-id { font-weight: 600; color: #3182ce; }
.modal-ef-num { font-weight: 600; color: #3182ce; }
.orc-cliente { max-width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.orc-projeto { max-width: 180px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.orc-ordem-compra { max-width: 110px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: #555; font-size: 0.88em; }
.orc-gestor { max-width: 120px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.orc-num { text-align: right; font-variant-numeric: tabular-nums; white-space: nowrap; }
.margem-pos { color: #059669; font-weight: 600; }
.margem-neg { color: #dc2626; font-weight: 600; }

.estado-badge {
    display: inline-block;
    padding: 3px 8px;
    border-radius: 12px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    white-space: nowrap;
}
.estado-orcamento { background: #fef3c7; color: #92400e; }
.estado-producao  { background: #dbeafe; color: #1e40af; }
.estado-enviado   { background: #ede9fe; color: #5b21b6; }
.estado-faturar   { background: #d1fae5; color: #065f46; }
.estado-concluido  { background: #f3f4f6; color: #374151; }
.estado-facturado  { background: #dcfce7; color: #166534; }
.estado-cancelado  { background: #fee2e2; color: #991b1b; }
.estado-pendente   { background: #fff7ed; color: #9a3412; }

.btn-del-orc {
    background: none; border: none; color: #aaa;
    cursor: pointer; font-size: 13px; padding: 4px 7px;
    border-radius: 4px;
}
.btn-del-orc:hover { background: #fee2e2; color: #dc2626; }

.orc-empty  { text-align: center; color: #aaa; padding: 40px; font-size: 14px; }
.orc-loading{ text-align: center; padding: 40px; color: #888; }

.orc-paginacao {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 4px 4px;
}
.orc-pag-info { font-size: 12px; color: #94a3b8; }
.orc-pag-btns { display: flex; align-items: center; gap: 4px; }

/* ---- Modais ---- */
.modal-overlay {
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.45);
    display: flex; align-items: center; justify-content: center;
    z-index: 1000; padding: 20px;
}

.modal-form {
    background: #fff;
    border-radius: 12px;
    width: 100%; max-width: 540px;
    box-shadow: 0 8px 40px rgba(0,0,0,0.18);
    overflow: hidden;
}

.modal-form-large {
    max-width: 700px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.modal-form-large .modal-form-body {
    overflow-y: auto;
    flex: 1 1;
}

.modal-contacto-section {
    border-top: 1px solid #f3f4f6;
    padding: 0 20px 4px;
}
.modal-contacto-title {
    font-size: 11px; font-weight: 700; color: #6b7280;
    text-transform: uppercase; letter-spacing: 0.5px;
    padding: 10px 0 0;
}
.modal-contacto-section .modal-form-grid {
    padding: 8px 0;
}

.modal-field select {
    padding: 7px 10px;
    border: 1px solid #dde1e7;
    border-radius: 5px;
    font-size: 13px;
    background: #fff;
}
.modal-field select:focus { outline: none; border-color: #3182ce; }

.modal-form-header {
    background: #1e40af; color: #fff;
    padding: 16px 20px;
    display: flex; align-items: center; justify-content: space-between;
    border-radius: 12px 12px 0 0;
    flex-shrink: 0;
}
.modal-form-header h3 { margin: 0; font-size: 16px; color: #fff; }

.modal-close { background: none; border: none; color: #fff; font-size: 18px; cursor: pointer; opacity: 0.7; }
.modal-close:hover { opacity: 1; }

.modal-form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    padding: 20px;
}

.modal-field { display: flex; flex-direction: column; gap: 4px; }
.modal-field.full { grid-column: 1 / -1; }

.modal-field label { font-size: 10px; font-weight: 700; color: #888; text-transform: uppercase; letter-spacing: 0.4px; }
.modal-field input, .modal-field textarea {
    padding: 7px 10px;
    border: 1px solid #dde1e7;
    border-radius: 5px;
    font-size: 13px;
}
.modal-field input:focus, .modal-field textarea:focus { outline: none; border-color: #3182ce; }

.modal-err { margin: 0 20px; padding: 8px 12px; background: #fee2e2; color: #dc2626; border-radius: 6px; font-size: 13px; }

.modal-form-actions {
    display: flex; justify-content: flex-end; gap: 10px;
    padding: 16px 20px;
    border-top: 1px solid #f3f4f6;
}

.btn-modal-cancel {
    background: #f3f4f6; border: 1px solid #dde1e7; color: #374151;
    padding: 8px 16px; border-radius: 6px; font-size: 13px; font-weight: 600; cursor: pointer;
}
.btn-modal-save {
    background: #3182ce; color: #fff; border: none;
    padding: 8px 18px; border-radius: 6px; font-size: 13px; font-weight: 600; cursor: pointer;
}
.btn-modal-save:disabled { opacity: 0.6; cursor: not-allowed; }
.btn-modal-save:hover:not(:disabled) { background: #2b6cb0; }

/* ---- Botão ver orçamento ---- */
.btn-ver-orc {
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    color: #1e40af;
    padding: 3px 10px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
}
.btn-ver-orc:hover { background: #dbeafe; }
.btn-edit-ef { background: none; border: none; cursor: pointer; font-size: 14px; padding: 2px 6px; border-radius: 4px; opacity: 0.7; }
.btn-edit-ef:hover { opacity: 1; background: #f3f4f6; }

/* ---- Filter tab buttons (shared style) ---- */
.gf-btn-group { display: flex; gap: 2px; background: #fff; padding: 3px; border-radius: 8px; width: fit-content; border: 1px solid #e2e8f0; }
.gf-btn-s { padding: 5px 12px; border: none; background: transparent; font-size: 12px; font-weight: 500; border-radius: 6px; cursor: pointer; transition: all 0.2s; white-space: nowrap; }
.gf-btn-s.active { background: #3182ce; color: #fff; box-shadow: 0 2px 4px rgba(49,130,206,0.2); }

/* ---- Estado EF badge ---- */
.ef-estado {
    border: none;
    border-radius: 12px;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    padding: 2px 10px;
    white-space: nowrap;
    display: inline-block;
}
.ef-estado-aguarda    { background: #fef3c7; color: #92400e; white-space: nowrap; }
.ef-estado-associada  { background: #dcfce7; color: #15803d; white-space: nowrap; }

/* ---- Tab Configurações ---- */
.cfg-page { display: flex; gap: 32px; flex-wrap: wrap; padding: 8px 0; align-items: flex-start; }
.cfg-section { flex: 1 1; min-width: 280px; background: #fff; border: 1px solid #e5e7eb; border-radius: 10px; padding: 20px; }
.cfg-section-title { font-size: 13px; font-weight: 600; color: #2d3748; margin-bottom: 14px; padding-bottom: 8px; border-bottom: 1px solid #e2e8f0; }
.cfg-add-row { display: flex; gap: 8px; margin-bottom: 12px; }
.cfg-input { flex: 1 1; padding: 8px 12px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 13px; font-family: inherit; background: #f9fafb; }
.cfg-input:focus { outline: none; border-color: #3182ce; box-shadow: 0 0 0 2px rgba(49,130,206,0.15); background: #fff; }
.cfg-btn-add { background: #3182ce; color: #fff; border: none; border-radius: 6px; padding: 8px 16px; font-size: 13px; font-weight: 600; cursor: pointer; white-space: nowrap; }
.cfg-btn-add:disabled { opacity: 0.5; cursor: not-allowed; }
.cfg-btn-add:not(:disabled):hover { background: #2b6cb0; }
.cfg-table { margin-top: 4px; }
.cfg-input-inline { width: 100%; padding: 6px 10px; border: 1px solid #3182ce; border-radius: 4px; font-size: 13px; font-family: inherit; outline: none; }
.cfg-btn-save  { background: #10b981; color: #fff; border: none; border-radius: 4px; padding: 3px 8px; font-size: 12px; font-weight: 700; cursor: pointer; margin-right: 4px; }
.cfg-btn-cancel { background: #f3f4f6; color: #374151; border: 1px solid #e2e8f0; border-radius: 4px; padding: 3px 8px; font-size: 12px; font-weight: 700; cursor: pointer; }
.cfg-btn-edit  { background: none; border: none; cursor: pointer; font-size: 13px; opacity: 0.6; margin-right: 4px; }
.cfg-btn-edit:hover { opacity: 1; }
.cfg-btn-del   { background: none; border: none; color: #ef4444; font-size: 15px; font-weight: 700; cursor: pointer; padding: 0 4px; }
.cfg-btn-del:hover { color: #b91c1c; }
.cfg-err { color: #dc2626; font-size: 12px; margin-bottom: 8px; }

/* ---- Import Excel ---- */
.import-section {
    margin-top: 28px;
    padding: 20px;
    background: #f8fafc;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
}

.import-section h3 {
    margin: 0 0 8px;
    font-size: 15px;
    font-weight: 700;
    color: #1e293b;
}

.import-desc {
    font-size: 13px;
    color: #64748b;
    margin: 0 0 16px;
    line-height: 1.5;
}

.import-controls {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-bottom: 12px;
}

.import-file-input {
    font-size: 13px;
    color: #475569;
}

.import-error {
    background: #fef2f2;
    color: #dc2626;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 13px;
    margin-top: 8px;
}

.import-result {
    margin-top: 12px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    padding: 14px;
}

.import-result-summary {
    display: flex;
    gap: 16px;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 8px;
}

.import-ok { color: #16a34a; }
.import-total { color: #64748b; font-weight: 400; }
.import-warn { color: #d97706; }

.import-estados-novos {
    font-size: 13px;
    color: #7c3aed;
    background: #f5f3ff;
    padding: 6px 10px;
    border-radius: 4px;
    margin: 8px 0;
}

.import-erros-list {
    font-size: 12px;
    color: #64748b;
    margin-top: 8px;
    max-height: 200px;
    overflow-y: auto;
}

.import-erros-list ul {
    margin: 4px 0 0;
    padding-left: 18px;
}

.import-erros-list li {
    margin-bottom: 2px;
}

.import-ultima {
    margin-top: 12px;
    padding: 12px 14px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.import-ultima-info {
    font-size: 13px;
    color: #475569;
}

.btn-danger {
    padding: 7px 16px;
    border: none;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    color: #fff;
    background: #dc2626;
    white-space: nowrap;
    transition: background 0.15s;
}

.btn-danger:hover { background: #b91c1c; }
.btn-danger:disabled { background: #fca5a5; cursor: not-allowed; }

.import-gestores-novos {
    font-size: 13px;
    color: #0369a1;
    background: #e0f2fe;
    padding: 6px 10px;
    border-radius: 4px;
    margin: 8px 0;
}

.import-placeholders {
    color: #6b7280;
    font-weight: 400;
    font-style: italic;
}

.import-revert-ok {
    border-color: #bbf7d0;
    background: #f0fdf4;
}

/* ============================================================
   ANÁLISE COMERCIAL
   ============================================================ */
.analise-page { padding: 4px 0; }

.analise-anos-selector {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 18px;
    flex-wrap: wrap;
}

.analise-selector-label {
    font-size: 13px;
    font-weight: 600;
    color: #64748b;
    margin-right: 4px;
}

.analise-ano-btn {
    padding: 5px 14px;
    border: 1.5px solid #cbd5e1;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    color: #64748b;
    background: #fff;
    transition: all 0.15s;
}
.analise-ano-btn:hover { border-color: #94a3b8; color: #1e293b; }
.analise-ano-btn.active { color: #fff; }

/* KPIs */
.analise-kpis {
    display: flex;
    gap: 14px;
    margin-bottom: 20px;
    flex-wrap: wrap;
}

.analise-kpi-card {
    flex: 1 1;
    min-width: 240px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-top: 3px solid #4f46e5;
    border-radius: 8px;
    padding: 14px 16px;
}

.analise-kpi-ano {
    font-size: 13px;
    font-weight: 700;
    color: #64748b;
    margin-bottom: 10px;
}

.analise-kpi-row {
    display: flex;
    gap: 16px;
}

.analise-kpi-item {
    display: flex;
    flex-direction: column;
    flex: 1 1;
}

.analise-kpi-val {
    font-size: 18px;
    font-weight: 700;
    color: #1e293b;
    line-height: 1.2;
}

.analise-kpi-label {
    font-size: 10px;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    margin-top: 2px;
}

/* Gráficos */
.analise-charts-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

.analise-chart-card {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 16px;
}

.analise-chart-full {
    grid-column: 1 / -1;
}

.analise-chart-card h4 {
    margin: 0 0 12px;
    font-size: 13px;
    font-weight: 700;
    color: #374151;
}

/* Tooltip */
.analise-tooltip {
    background: #1e293b;
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 12px;
    color: #fff;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.analise-tooltip-label {
    font-weight: 700;
    margin-bottom: 4px;
    color: #94a3b8;
    font-size: 11px;
}

/* ============================================================
   FILTROS DE COLUNA (estilo Excel)
   ============================================================ */
.col-filter-wrap {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 2px;
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
}

.col-filter-btn {
    background: none;
    border: none;
    padding: 2px 4px;
    cursor: pointer;
    border-radius: 3px;
    display: inline-flex;
    align-items: center;
    gap: 3px;
    font-size: 10.5px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #94a3b8;
    transition: color 0.1s, background 0.1s;
}
.col-filter-btn:hover { color: #475569; background: #f1f5f9; }
.col-filter-btn.filtered { color: #3182ce; }
.col-filter-btn.sorted   { color: #7c3aed; }
.col-filter-btn.filtered.sorted { color: #3182ce; }

.col-filter-arrow {
    font-size: 9px;
    opacity: 0.7;
}

.col-filter-indicator {
    font-size: 8px;
    color: #3182ce;
    font-weight: 900;
}

.col-filter-dropdown {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.14);
    padding: 8px 0;
    min-width: 180px;
    max-width: 260px;
}

.col-filter-sort {
    display: flex;
    gap: 4px;
    padding: 4px 10px 8px;
    border-bottom: 1px solid #f1f5f9;
    margin-bottom: 4px;
}

.col-filter-sort-btn {
    flex: 1 1;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 5px;
    padding: 4px 8px;
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    cursor: pointer;
    transition: all 0.1s;
}
.col-filter-sort-btn:hover { background: #e2e8f0; color: #1e293b; }
.col-filter-sort-btn.active { background: #7c3aed; color: #fff; border-color: #7c3aed; }

.col-filter-search {
    width: calc(100% - 20px);
    margin: 0 10px 6px;
    padding: 5px 8px;
    border: 1px solid #e2e8f0;
    border-radius: 5px;
    font-size: 12px;
    outline: none;
    box-sizing: border-box;
}
.col-filter-search:focus { border-color: #3182ce; }

.col-filter-actions {
    display: flex;
    gap: 4px;
    padding: 0 10px 6px;
    border-bottom: 1px solid #f1f5f9;
}

.col-filter-action-btn {
    font-size: 11px;
    color: #3182ce;
    background: none;
    border: none;
    cursor: pointer;
    padding: 2px 0;
}
.col-filter-action-btn:hover { text-decoration: underline; }

.col-filter-list {
    max-height: 200px;
    overflow-y: auto;
    padding: 2px 0;
}

.col-filter-item {
    display: flex;
    align-items: center;
    gap: 7px;
    padding: 4px 12px;
    font-size: 12px;
    color: #374151;
    cursor: pointer;
    transition: background 0.1s;
}
.col-filter-item:hover { background: #f0f4ff; }
.col-filter-item input[type="checkbox"] {
    width: 13px;
    height: 13px;
    margin: 0;
    cursor: pointer;
    accent-color: #3182ce;
}

/* Coluna "Fatura" das Encomendas Fornecedor.
   As etiquetas embrulham em vez de alargarem a coluna, porque há EFs
   repartidas por 3 ou 4 faturas e alguns números têm 10 dígitos. */
.orc-fat-cel {
    display: flex;
    flex-wrap: wrap;
    gap: 3px;
    max-width: 130px;
}
.orc-fat-tag {
    background: #dcfce7;
    color: #15803d;
    border-radius: 4px;
    padding: 2px 6px;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
}
.orc-fat-tag-generica { background: #fef3c7; color: #92400e; }
.orc-fat-vazio { color: #94a3b8; font-size: 13px; }

/* Notas dentro do filtro de coluna: "a carregar", "sem valores", ou o aviso de
   que a lista de valores foi cortada. */
.col-filter-nota {
    padding: 6px 10px;
    font-size: 0.75rem;
    color: #64748b;
    font-style: italic;
}

.ef-action { padding: 5px 10px; border: 1px solid; border-radius: 6px; background: none; cursor: pointer; font-size: 12px; font-weight: 600; }
.ef-action-warning { border-color: #f59e0b; color: #b45309; }
.ef-action-danger { border-color: #dc2626; color: #dc2626; }
.ef-action-undo { padding: 5px 12px; border-color: #ef4444; color: #ef4444; }
`, "",{"version":3,"sources":["webpack://./src/pages/Orcamentos.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAO;AACX;;;AAGA,qCAAqC;AACrC;IACI,gBAAgB;IAChB,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA,qDAAqD;AACrD;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA,wBAAwB,cAAc,EAAE,iCAAiC,EAAE;AAC3E,yBAAyB,gBAAgB,EAAE,cAAc,EAAE,qCAAqC,EAAE;;;AAGlG;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA,qBAAqB,cAAc,EAAE,qBAAqB,EAAE;AAC5D,sBAAsB,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE;;AAE/E,mBAAmB,aAAa,EAAE;;AAElC,+BAA+B;AAC/B;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA,uBAAuB,mBAAmB,EAAE;;AAE5C;IACI,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA,6CAA6C,mBAAmB,EAAE;AAClE,iCAAiC,YAAY,EAAE,eAAe,EAAE;;AAEhE;IACI,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;AACA,mCAAmC,mBAAmB,EAAE;AACxD,uBAAuB,YAAY,EAAE,mBAAmB,EAAE;;AAE1D;IACI,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;AACA,sBAAsB,mBAAmB,EAAE;;AAE3C;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;AACA,cAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD,cAAc,mBAAmB,EAAE,cAAc,EAAE;;AAEnD,+CAA+C;AAC/C;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gDAAgD;AACpD;AACA,oBAAoB,uCAAuC,EAAE;AAC7D,4BAA4B,0BAA0B,EAAE;;AAExD,eAAe,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAClE,eAAe,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,kBAAkB,EAAE;;AAEzI,oBAAoB,cAAc,EAAE;AACpC,oBAAoB,cAAc,EAAE;AACpC,oBAAoB,cAAc,EAAE;AACpC,oBAAoB,cAAc,EAAE;AACpC,oBAAoB,cAAc,EAAE;;AAEpC,mCAAmC;AACnC;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;AACA,6BAA6B,qBAAqB,EAAE;;AAEpD;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;AACA,oCAAoC,UAAU,EAAE;AAChD,0CAA0C,mBAAmB,EAAE,mBAAmB,EAAE;;AAEpF,cAAc;AACd;IACI,aAAa;IACb,qCAAqC;IACrC,iBAAiB;AACrB;AACA,gCAAgC,+BAA+B,EAAE;AACjE,8CAA8C,kBAAkB,EAAE;;AAElE;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,6BAA6B;IAC7B,WAAW;AACf;AACA,uBAAuB,mBAAmB,EAAE;;AAE5C,eAAe,gBAAgB,EAAE,cAAc,EAAE,cAAc,EAAE,eAAe,EAAE,mBAAmB,EAAE;AACvG,oBAAoB,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,cAAc,EAAE,cAAc,EAAE;AACtJ,gBAAgB,cAAc,EAAE,cAAc,EAAE;AAChD,iBAAiB,cAAc,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,SAAO,EAAE,YAAY,EAAE;;AAExH,0DAA0D;AAC1D;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,SAAO,EAAE,YAAY,EAAE,WAAW;IAClC,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA,cAAc,gBAAgB,EAAE;;AAEhC;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,WAAW;AACf;AACA,oBAAoB,mBAAmB,EAAE;;AAEzC;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;AACA,0BAA0B,mBAAmB,EAAE;;AAE/C;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;AACA,sBAAsB,cAAc,EAAE,qBAAqB,EAAE;AAC7D,8BAA8B,oBAAoB,EAAE;AACpD,sBAAsB,oBAAoB,EAAE;;AAE5C,qBAAqB;AACrB;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA,aAAa,WAAW,EAAE,yBAAyB,EAAE,iBAAiB,EAAE;AACxE,sBAAsB,mBAAmB,EAAE;AAC3C,gBAAgB,gBAAgB,EAAE,gCAAgC,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,cAAc,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAChM,gBAAgB,gBAAgB,EAAE,gCAAgC,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACnI,uBAAuB,gBAAgB,EAAE,cAAc,EAAE;AACzD,WAAW,eAAe,EAAE,2BAA2B,EAAE;AACzD,iBAAiB,mBAAmB,EAAE;;AAEtC,UAAU,gBAAgB,EAAE,cAAc,EAAE;AAC5C,gBAAgB,gBAAgB,EAAE,cAAc,EAAE;AAClD,eAAe,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACjG,eAAe,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACjG,oBAAoB,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,WAAW,EAAE,iBAAiB,EAAE;AACtI,cAAc,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAChG,WAAW,iBAAiB,EAAE,kCAAkC,EAAE,mBAAmB,EAAE;AACvF,cAAc,cAAc,EAAE,gBAAgB,EAAE;AAChD,cAAc,cAAc,EAAE,gBAAgB,EAAE;;AAEhD;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB;AACA,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D;IACI,gBAAgB,EAAE,YAAY,EAAE,WAAW;IAC3C,eAAe,EAAE,eAAe,EAAE,gBAAgB;IAClD,kBAAkB;AACtB;AACA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D,cAAc,kBAAkB,EAAE,WAAW,EAAE,aAAa,EAAE,eAAe,EAAE;AAC/E,cAAc,kBAAkB,EAAE,aAAa,EAAE,WAAW,EAAE;;AAE9D;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;AACzB;AACA,gBAAgB,eAAe,EAAE,cAAc,EAAE;AACjD,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAE9D,qBAAqB;AACrB;IACI,eAAe,EAAE,QAAQ;IACzB,4BAA4B;IAC5B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;IAC3D,aAAa,EAAE,aAAa;AAChC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW,EAAE,gBAAgB;IAC7B,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,SAAO;AACX;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;AACvB;AACA;IACI,eAAe,EAAE,gBAAgB,EAAE,cAAc;IACjD,yBAAyB,EAAE,qBAAqB;IAChD,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA,4BAA4B,aAAa,EAAE,qBAAqB,EAAE;;AAElE;IACI,mBAAmB,EAAE,WAAW;IAChC,kBAAkB;IAClB,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;IAClE,4BAA4B;IAC5B,cAAc;AAClB;AACA,wBAAwB,SAAS,EAAE,eAAe,EAAE,WAAW,EAAE;;AAEjE,eAAe,gBAAgB,EAAE,YAAY,EAAE,WAAW,EAAE,eAAe,EAAE,eAAe,EAAE,YAAY,EAAE;AAC5G,qBAAqB,UAAU,EAAE;;AAEjC;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,aAAa;AACjB;;AAEA,eAAe,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAChE,oBAAoB,mBAAmB,EAAE;;AAEzC,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,yBAAyB,EAAE,qBAAqB,EAAE;AACvH;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;AACA,wDAAwD,aAAa,EAAE,qBAAqB,EAAE;;AAE9F,aAAa,cAAc,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,cAAc,EAAE,kBAAkB,EAAE,eAAe,EAAE;;AAE1H;IACI,aAAa,EAAE,yBAAyB,EAAE,SAAS;IACnD,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB,EAAE,yBAAyB,EAAE,cAAc;IAC9D,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe;AAC7F;AACA;IACI,mBAAmB,EAAE,WAAW,EAAE,YAAY;IAC9C,iBAAiB,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe;AAC7F;AACA,2BAA2B,YAAY,EAAE,mBAAmB,EAAE;AAC9D,uCAAuC,mBAAmB,EAAE;;AAE5D,kCAAkC;AAClC;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;AACA,qBAAqB,mBAAmB,EAAE;AAC1C,eAAe,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,YAAY,EAAE;AACrI,qBAAqB,UAAU,EAAE,mBAAmB,EAAE;;AAEtD,gDAAgD;AAChD,gBAAgB,aAAa,EAAE,QAAQ,EAAE,gBAAgB,EAAE,YAAY,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE;AAC5I,YAAY,iBAAiB,EAAE,YAAY,EAAE,uBAAuB,EAAE,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE,oBAAoB,EAAE,mBAAmB,EAAE;AACzL,mBAAmB,mBAAmB,EAAE,WAAW,EAAE,0CAA0C,EAAE;;AAEjG,8BAA8B;AAC9B;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;AACzB;AACA,wBAAwB,mBAAmB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAClF,wBAAwB,mBAAmB,EAAE,cAAc,EAAE,mBAAmB,EAAE;;AAElF,gCAAgC;AAChC,YAAY,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE,cAAc,EAAE,uBAAuB,EAAE;AAChG,eAAe,SAAO,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,aAAa,EAAE;AAC3H,qBAAqB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,gCAAgC,EAAE;AACpJ,eAAe,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAC7D,aAAa,SAAO,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,eAAe,EAAE,oBAAoB,EAAE,mBAAmB,EAAE;AACpJ,mBAAmB,aAAa,EAAE,qBAAqB,EAAE,2CAA2C,EAAE,gBAAgB,EAAE;AACxH,eAAe,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,mBAAmB,EAAE;AAC/K,wBAAwB,YAAY,EAAE,mBAAmB,EAAE;AAC3D,oCAAoC,mBAAmB,EAAE;AACzD,aAAa,eAAe,EAAE;AAC9B,oBAAoB,WAAW,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,eAAe,EAAE,oBAAoB,EAAE,aAAa,EAAE;AACzJ,iBAAiB,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,iBAAiB,EAAE;AAC9K,kBAAkB,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC5K,iBAAiB,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,eAAe,EAAE,YAAY,EAAE,iBAAiB,EAAE;AACpH,sBAAsB,UAAU,EAAE;AAClC,iBAAiB,gBAAgB,EAAE,YAAY,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE;AACrI,qBAAqB,cAAc,EAAE;AACrC,WAAW,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE;;AAEhE,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,aAAa,cAAc,EAAE;AAC7B,gBAAgB,cAAc,EAAE,gBAAgB,EAAE;AAClD,eAAe,cAAc,EAAE;;AAE/B;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA,oBAAoB,mBAAmB,EAAE;AACzC,uBAAuB,mBAAmB,EAAE,mBAAmB,EAAE;;AAEjE;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;iEAEiE;AACjE,gBAAgB,cAAc,EAAE;;AAEhC;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;AACA,yBAAyB,qBAAqB,EAAE,cAAc,EAAE;AAChE,0BAA0B,WAAW,EAAE;;AAEvC,SAAS;AACT;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAO;AACX;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;AACnB;;AAEA,aAAa;AACb;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,YAAY;AACZ;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;;iEAEiE;AACjE;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,uCAAuC;AAC3C;AACA,wBAAwB,cAAc,EAAE,mBAAmB,EAAE;AAC7D,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,cAAc,EAAE;AAC3C,kCAAkC,cAAc,EAAE;;AAElD;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;IACvC,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,qBAAqB;IACrB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;AACA,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE,8BAA8B,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE;;AAEvF;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;AACA,2BAA2B,qBAAqB,EAAE;;AAElD;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;AACA,+BAA+B,0BAA0B,EAAE;;AAE3D;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,eAAe;IACf,2BAA2B;AAC/B;AACA,yBAAyB,mBAAmB,EAAE;AAC9C;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,eAAe;IACf,qBAAqB;AACzB;;AAEA;;mEAEmE;AACnE;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D,iBAAiB,cAAc,EAAE,eAAe,EAAE;;AAElD;wCACwC;AACxC;IACI,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA,aAAa,iBAAiB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC7I,qBAAqB,qBAAqB,EAAE,cAAc,EAAE;AAC5D,oBAAoB,qBAAqB,EAAE,cAAc,EAAE;AAC3D,kBAAkB,iBAAiB,EAAE,qBAAqB,EAAE,cAAc,EAAE","sourcesContent":[".orc-page {\r\n    background: #f5f6fa;\r\n    min-height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.orc-body {\r\n    padding: 24px;\r\n    flex: 1;\r\n}\r\n\r\n\r\n/* ---- Card branco (conteúdo) ---- */\r\n.orc-card {\r\n    background: #fff;\r\n    border-radius: 10px;\r\n    box-shadow: 0 1px 8px rgba(0,0,0,0.07);\r\n}\r\n\r\n/* ---- Sub-navbar (fora do card, botões pill) ---- */\r\n.orc-subnav {\r\n    display: flex;\r\n    gap: 4px;\r\n    background: #e2e8f0;\r\n    border-radius: 8px;\r\n    padding: 3px;\r\n    margin-bottom: 14px;\r\n    width: fit-content;\r\n}\r\n\r\n.orc-subnav-btn {\r\n    padding: 8px 20px;\r\n    border: none;\r\n    border-radius: 6px;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    color: #64748b;\r\n    background: transparent;\r\n    transition: all 0.15s;\r\n    white-space: nowrap;\r\n}\r\n\r\n.orc-subnav-btn:hover { color: #1e293b; background: rgba(255,255,255,0.6); }\r\n.orc-subnav-btn.active { background: #fff; color: #3182ce; box-shadow: 0 1px 4px rgba(0,0,0,0.1); }\r\n\r\n\r\n.orc-ano-btn {\r\n    padding: 6px 18px;\r\n    border: 1px solid #cbd5e1;\r\n    border-radius: 6px;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    color: #64748b;\r\n    background: #fff;\r\n    transition: all 0.15s;\r\n    white-space: nowrap;\r\n}\r\n\r\n.orc-ano-btn:hover { color: #1e293b; border-color: #94a3b8; }\r\n.orc-ano-btn.active { background: #3182ce; color: #fff; border-color: #3182ce; }\r\n\r\n.orc-tab-content { padding: 20px; }\r\n\r\n/* ---- Toolbar dos tabs ---- */\r\n.tab-toolbar {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin-bottom: 12px;\r\n    flex-wrap: wrap;\r\n    gap: 8px;\r\n}\r\n\r\n.tab-toolbar-right {\r\n    display: flex;\r\n    gap: 8px;\r\n    align-items: center;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.btn-novo-item {\r\n    background: #3182ce;\r\n    color: #fff;\r\n    border: none;\r\n    border-radius: 6px;\r\n    padding: 8px 16px;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n}\r\n.btn-novo-item:hover { background: #2b6cb0; }\r\n\r\n.btn-secondary-action {\r\n    background: #fff;\r\n    color: #374151;\r\n    border: 1px solid #d1d5db;\r\n    border-radius: 6px;\r\n    padding: 8px 14px;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n}\r\n.btn-secondary-action:hover:not(:disabled) { background: #f3f4f6; }\r\n.btn-secondary-action:disabled { opacity: 0.6; cursor: default; }\r\n\r\n.btn-import {\r\n    background: #fff;\r\n    border: 1px solid #d1d5db;\r\n    color: #374151;\r\n    border-radius: 6px;\r\n    padding: 8px 14px;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n}\r\n.btn-import:hover:not(:disabled) { background: #f3f4f6; }\r\n.btn-import:disabled { opacity: 0.6; cursor: not-allowed; }\r\n\r\n.btn-template {\r\n    background: #fff;\r\n    border: 1px solid #d1d5db;\r\n    color: #374151;\r\n    border-radius: 6px;\r\n    padding: 8px 14px;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    text-decoration: none;\r\n}\r\n.btn-template:hover { background: #f3f4f6; }\r\n\r\n.import-msg {\r\n    padding: 8px 14px;\r\n    border-radius: 6px;\r\n    font-size: 13px;\r\n    margin-bottom: 12px;\r\n}\r\n.import-ok  { background: #d1fae5; color: #065f46; }\r\n.import-err { background: #fee2e2; color: #dc2626; }\r\n\r\n/* ---- Painéis — linha única full width ---- */\r\n.orc-paineis {\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap: 10px;\r\n    margin-bottom: 10px;\r\n    width: 100%;\r\n}\r\n\r\n.orc-painel {\r\n    flex: 1;\r\n    background: #fff;\r\n    border-radius: 8px;\r\n    padding: 10px 14px;\r\n    cursor: pointer;\r\n    border: 2px solid transparent;\r\n    box-shadow: 0 1px 4px rgba(0,0,0,0.06);\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    transition: box-shadow 0.15s, border-color 0.15s;\r\n}\r\n.orc-painel:hover { box-shadow: 0 3px 10px rgba(0,0,0,0.12); }\r\n.orc-painel.painel-active { border-color: currentColor; }\r\n\r\n.painel-num  { font-size: 22px; font-weight: 700; line-height: 1; }\r\n.painel-label{ font-size: 10px; font-weight: 600; margin-top: 3px; text-transform: uppercase; letter-spacing: 0.4px; text-align: center; }\r\n\r\n.painel-todos     { color: #6366f1; }\r\n.painel-orcamento { color: #f59e0b; }\r\n.painel-producao  { color: #3b82f6; }\r\n.painel-enviado   { color: #8b5cf6; }\r\n.painel-faturar   { color: #10b981; }\r\n\r\n/* ---- Painel Entregas Hoje ---- */\r\n.orc-hoje-panel {\r\n    width: 100%;\r\n    background: #fff;\r\n    border-radius: 8px;\r\n    box-shadow: 0 1px 4px rgba(0,0,0,0.06);\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n    border: 1px solid #e2e8f0;\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.orc-hoje-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 7px 14px;\r\n    border-bottom: 1px solid #f0f4f8;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n    color: #1e293b;\r\n    background: #f8fafc;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.orc-hoje-header-right {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.orc-hoje-gestor-sel {\r\n    font-size: 11px;\r\n    font-weight: 500;\r\n    color: #475569;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 5px;\r\n    padding: 3px 8px;\r\n    background: #fff;\r\n    cursor: pointer;\r\n    outline: none;\r\n}\r\n.orc-hoje-gestor-sel:focus { border-color: #3182ce; }\r\n\r\n.orc-hoje-count {\r\n    background: #fee2e2;\r\n    color: #dc2626;\r\n    font-size: 11px;\r\n    font-weight: 700;\r\n    padding: 1px 7px;\r\n    border-radius: 10px;\r\n}\r\n\r\n.orc-hoje-list {\r\n    overflow-y: auto;\r\n    max-height: 136px;\r\n    background: #fff;\r\n}\r\n.orc-hoje-list::-webkit-scrollbar { width: 4px; }\r\n.orc-hoje-list::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }\r\n\r\n/* 3 colunas */\r\n.orc-hoje-3col {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    max-height: 140px;\r\n}\r\n.orc-hoje-3col .orc-hoje-item { border-right: 1px solid #f0f4f8; }\r\n.orc-hoje-3col .orc-hoje-item:nth-child(3n) { border-right: none; }\r\n\r\n.orc-hoje-empty {\r\n    padding: 14px;\r\n    text-align: center;\r\n    color: #94a3b8;\r\n    font-size: 12px;\r\n    grid-column: 1 / -1;\r\n}\r\n\r\n.orc-hoje-item {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n    padding: 1px 8px;\r\n    border-bottom: 1px solid #f3f4f6;\r\n    cursor: pointer;\r\n    transition: background 0.1s;\r\n    line-height: 1.2;\r\n    font-size: 11px;\r\n    transform: scale(0.82);\r\n    transform-origin: left center;\r\n    color: #333;\r\n}\r\n.orc-hoje-item:hover { background: #f0f4ff; }\r\n\r\n.orc-hoje-id { font-weight: 600; color: #94a3b8; flex-shrink: 0; min-width: 38px; white-space: nowrap; }\r\n.orc-hoje-cliente { font-weight: 600; color: #1e293b; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex-shrink: 0; max-width: 38%; }\r\n.orc-hoje-sep { color: #d1d5db; flex-shrink: 0; }\r\n.orc-hoje-proj { color: #64748b; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex: 1; min-width: 0; }\r\n\r\n/* ---- Filtro por ano — sempre por baixo do subnav ---- */\r\n.orc-ano-filter {\r\n    display: flex;\r\n    gap: 6px;\r\n    margin-bottom: 14px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n/* ---- Filtros ---- */\r\n.orc-filtros {\r\n    display: flex;\r\n    gap: 8px;\r\n    margin-bottom: 14px;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n}\r\n\r\n.orc-input-search {\r\n    flex: 1; min-width: 0; width: 100%;\r\n    padding: 10px 14px;\r\n    height: 40px;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    background: #fff;\r\n    box-sizing: border-box;\r\n}\r\n.orc-input-search:focus {\r\n    outline: none;\r\n    border-color: #3182ce;\r\n    box-shadow: 0 0 0 2px rgba(49, 130, 206, 0.15);\r\n}\r\n\r\n.orc-select, .orc-input-date {\r\n    padding: 10px 14px;\r\n    height: 40px;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 8px;\r\n    font-size: 14px;\r\n    background: #fff;\r\n    box-sizing: border-box;\r\n}\r\n.orc-select:focus, .orc-input-date:focus {\r\n    outline: none;\r\n    border-color: #3182ce;\r\n    box-shadow: 0 0 0 2px rgba(49, 130, 206, 0.15);\r\n}\r\n\r\n.orc-select { min-width: 130px; }\r\n\r\n.btn-limpar {\r\n    padding: 8px 12px;\r\n    border: 1px solid #dde1e7;\r\n    border-radius: 6px;\r\n    background: #fff;\r\n    font-size: 13px;\r\n    cursor: pointer;\r\n    color: #666;\r\n}\r\n.btn-limpar:hover { background: #f3f4f6; }\r\n\r\n.btn-excel-export {\r\n    padding: 8px 12px;\r\n    border: 1px solid #16a34a;\r\n    border-radius: 6px;\r\n    background: #f0fdf4;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    color: #16a34a;\r\n    margin-left: auto;\r\n}\r\n.btn-excel-export:hover { background: #dcfce7; }\r\n\r\n.orc-id-wrap {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 5px;\r\n}\r\n.btn-copy-id {\r\n    display: none;\r\n    background: none;\r\n    border: 1px solid #cbd5e1;\r\n    border-radius: 4px;\r\n    padding: 1px 5px;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n    color: #64748b;\r\n    line-height: 1.2;\r\n    flex-shrink: 0;\r\n}\r\n.btn-copy-id.copied { color: #16a34a; border-color: #86efac; }\r\n.orc-row:hover .btn-copy-id { display: inline-flex; }\r\n.btn-copy-id.copied { display: inline-flex; }\r\n\r\n/* ---- Tabela ---- */\r\n.orc-table-wrap {\r\n    background: #fff;\r\n    border-radius: 8px;\r\n    border: 1px solid #e5e7eb;\r\n    overflow: auto;\r\n}\r\n\r\n.orc-table { width: 100%; border-collapse: collapse; font-size: 12.5px; }\r\n.orc-table thead tr { background: #f8fafc; }\r\n.orc-table th { padding: 5px 8px; border-bottom: 1px solid #e5e7eb; font-size: 10.5px; text-transform: uppercase; letter-spacing: 0.4px; color: #94a3b8; font-weight: 700; white-space: nowrap; }\r\n.orc-table td { padding: 3px 8px; border-bottom: 1px solid #f3f4f6; vertical-align: middle; white-space: nowrap; line-height: 1.4; }\r\n.orc-table td strong { font-weight: 600; color: #4a5568; }\r\n.orc-row { cursor: pointer; transition: background 0.1s; }\r\n.orc-row:hover { background: #f0f4ff; }\r\n\r\n.orc-id { font-weight: 600; color: #3182ce; }\r\n.modal-ef-num { font-weight: 600; color: #3182ce; }\r\n.orc-cliente { max-width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\r\n.orc-projeto { max-width: 180px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\r\n.orc-ordem-compra { max-width: 110px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: #555; font-size: 0.88em; }\r\n.orc-gestor { max-width: 120px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\r\n.orc-num { text-align: right; font-variant-numeric: tabular-nums; white-space: nowrap; }\r\n.margem-pos { color: #059669; font-weight: 600; }\r\n.margem-neg { color: #dc2626; font-weight: 600; }\r\n\r\n.estado-badge {\r\n    display: inline-block;\r\n    padding: 3px 8px;\r\n    border-radius: 12px;\r\n    font-size: 10px;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.3px;\r\n    white-space: nowrap;\r\n}\r\n.estado-orcamento { background: #fef3c7; color: #92400e; }\r\n.estado-producao  { background: #dbeafe; color: #1e40af; }\r\n.estado-enviado   { background: #ede9fe; color: #5b21b6; }\r\n.estado-faturar   { background: #d1fae5; color: #065f46; }\r\n.estado-concluido  { background: #f3f4f6; color: #374151; }\r\n.estado-facturado  { background: #dcfce7; color: #166534; }\r\n.estado-cancelado  { background: #fee2e2; color: #991b1b; }\r\n.estado-pendente   { background: #fff7ed; color: #9a3412; }\r\n\r\n.btn-del-orc {\r\n    background: none; border: none; color: #aaa;\r\n    cursor: pointer; font-size: 13px; padding: 4px 7px;\r\n    border-radius: 4px;\r\n}\r\n.btn-del-orc:hover { background: #fee2e2; color: #dc2626; }\r\n\r\n.orc-empty  { text-align: center; color: #aaa; padding: 40px; font-size: 14px; }\r\n.orc-loading{ text-align: center; padding: 40px; color: #888; }\r\n\r\n.orc-paginacao {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 10px 4px 4px;\r\n}\r\n.orc-pag-info { font-size: 12px; color: #94a3b8; }\r\n.orc-pag-btns { display: flex; align-items: center; gap: 4px; }\r\n\r\n/* ---- Modais ---- */\r\n.modal-overlay {\r\n    position: fixed; inset: 0;\r\n    background: rgba(0,0,0,0.45);\r\n    display: flex; align-items: center; justify-content: center;\r\n    z-index: 1000; padding: 20px;\r\n}\r\n\r\n.modal-form {\r\n    background: #fff;\r\n    border-radius: 12px;\r\n    width: 100%; max-width: 540px;\r\n    box-shadow: 0 8px 40px rgba(0,0,0,0.18);\r\n    overflow: hidden;\r\n}\r\n\r\n.modal-form-large {\r\n    max-width: 700px;\r\n    max-height: 90vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow: hidden;\r\n}\r\n.modal-form-large .modal-form-body {\r\n    overflow-y: auto;\r\n    flex: 1;\r\n}\r\n\r\n.modal-contacto-section {\r\n    border-top: 1px solid #f3f4f6;\r\n    padding: 0 20px 4px;\r\n}\r\n.modal-contacto-title {\r\n    font-size: 11px; font-weight: 700; color: #6b7280;\r\n    text-transform: uppercase; letter-spacing: 0.5px;\r\n    padding: 10px 0 0;\r\n}\r\n.modal-contacto-section .modal-form-grid {\r\n    padding: 8px 0;\r\n}\r\n\r\n.modal-field select {\r\n    padding: 7px 10px;\r\n    border: 1px solid #dde1e7;\r\n    border-radius: 5px;\r\n    font-size: 13px;\r\n    background: #fff;\r\n}\r\n.modal-field select:focus { outline: none; border-color: #3182ce; }\r\n\r\n.modal-form-header {\r\n    background: #1e40af; color: #fff;\r\n    padding: 16px 20px;\r\n    display: flex; align-items: center; justify-content: space-between;\r\n    border-radius: 12px 12px 0 0;\r\n    flex-shrink: 0;\r\n}\r\n.modal-form-header h3 { margin: 0; font-size: 16px; color: #fff; }\r\n\r\n.modal-close { background: none; border: none; color: #fff; font-size: 18px; cursor: pointer; opacity: 0.7; }\r\n.modal-close:hover { opacity: 1; }\r\n\r\n.modal-form-grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 10px;\r\n    padding: 20px;\r\n}\r\n\r\n.modal-field { display: flex; flex-direction: column; gap: 4px; }\r\n.modal-field.full { grid-column: 1 / -1; }\r\n\r\n.modal-field label { font-size: 10px; font-weight: 700; color: #888; text-transform: uppercase; letter-spacing: 0.4px; }\r\n.modal-field input, .modal-field textarea {\r\n    padding: 7px 10px;\r\n    border: 1px solid #dde1e7;\r\n    border-radius: 5px;\r\n    font-size: 13px;\r\n}\r\n.modal-field input:focus, .modal-field textarea:focus { outline: none; border-color: #3182ce; }\r\n\r\n.modal-err { margin: 0 20px; padding: 8px 12px; background: #fee2e2; color: #dc2626; border-radius: 6px; font-size: 13px; }\r\n\r\n.modal-form-actions {\r\n    display: flex; justify-content: flex-end; gap: 10px;\r\n    padding: 16px 20px;\r\n    border-top: 1px solid #f3f4f6;\r\n}\r\n\r\n.btn-modal-cancel {\r\n    background: #f3f4f6; border: 1px solid #dde1e7; color: #374151;\r\n    padding: 8px 16px; border-radius: 6px; font-size: 13px; font-weight: 600; cursor: pointer;\r\n}\r\n.btn-modal-save {\r\n    background: #3182ce; color: #fff; border: none;\r\n    padding: 8px 18px; border-radius: 6px; font-size: 13px; font-weight: 600; cursor: pointer;\r\n}\r\n.btn-modal-save:disabled { opacity: 0.6; cursor: not-allowed; }\r\n.btn-modal-save:hover:not(:disabled) { background: #2b6cb0; }\r\n\r\n/* ---- Botão ver orçamento ---- */\r\n.btn-ver-orc {\r\n    background: #eff6ff;\r\n    border: 1px solid #bfdbfe;\r\n    color: #1e40af;\r\n    padding: 3px 10px;\r\n    border-radius: 4px;\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    white-space: nowrap;\r\n}\r\n.btn-ver-orc:hover { background: #dbeafe; }\r\n.btn-edit-ef { background: none; border: none; cursor: pointer; font-size: 14px; padding: 2px 6px; border-radius: 4px; opacity: 0.7; }\r\n.btn-edit-ef:hover { opacity: 1; background: #f3f4f6; }\r\n\r\n/* ---- Filter tab buttons (shared style) ---- */\r\n.gf-btn-group { display: flex; gap: 2px; background: #fff; padding: 3px; border-radius: 8px; width: fit-content; border: 1px solid #e2e8f0; }\r\n.gf-btn-s { padding: 5px 12px; border: none; background: transparent; font-size: 12px; font-weight: 500; border-radius: 6px; cursor: pointer; transition: all 0.2s; white-space: nowrap; }\r\n.gf-btn-s.active { background: #3182ce; color: #fff; box-shadow: 0 2px 4px rgba(49,130,206,0.2); }\r\n\r\n/* ---- Estado EF badge ---- */\r\n.ef-estado {\r\n    border: none;\r\n    border-radius: 12px;\r\n    font-size: 10px;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.3px;\r\n    padding: 2px 10px;\r\n    white-space: nowrap;\r\n    display: inline-block;\r\n}\r\n.ef-estado-aguarda    { background: #fef3c7; color: #92400e; white-space: nowrap; }\r\n.ef-estado-associada  { background: #dcfce7; color: #15803d; white-space: nowrap; }\r\n\r\n/* ---- Tab Configurações ---- */\r\n.cfg-page { display: flex; gap: 32px; flex-wrap: wrap; padding: 8px 0; align-items: flex-start; }\r\n.cfg-section { flex: 1; min-width: 280px; background: #fff; border: 1px solid #e5e7eb; border-radius: 10px; padding: 20px; }\r\n.cfg-section-title { font-size: 13px; font-weight: 600; color: #2d3748; margin-bottom: 14px; padding-bottom: 8px; border-bottom: 1px solid #e2e8f0; }\r\n.cfg-add-row { display: flex; gap: 8px; margin-bottom: 12px; }\r\n.cfg-input { flex: 1; padding: 8px 12px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 13px; font-family: inherit; background: #f9fafb; }\r\n.cfg-input:focus { outline: none; border-color: #3182ce; box-shadow: 0 0 0 2px rgba(49,130,206,0.15); background: #fff; }\r\n.cfg-btn-add { background: #3182ce; color: #fff; border: none; border-radius: 6px; padding: 8px 16px; font-size: 13px; font-weight: 600; cursor: pointer; white-space: nowrap; }\r\n.cfg-btn-add:disabled { opacity: 0.5; cursor: not-allowed; }\r\n.cfg-btn-add:not(:disabled):hover { background: #2b6cb0; }\r\n.cfg-table { margin-top: 4px; }\r\n.cfg-input-inline { width: 100%; padding: 6px 10px; border: 1px solid #3182ce; border-radius: 4px; font-size: 13px; font-family: inherit; outline: none; }\r\n.cfg-btn-save  { background: #10b981; color: #fff; border: none; border-radius: 4px; padding: 3px 8px; font-size: 12px; font-weight: 700; cursor: pointer; margin-right: 4px; }\r\n.cfg-btn-cancel { background: #f3f4f6; color: #374151; border: 1px solid #e2e8f0; border-radius: 4px; padding: 3px 8px; font-size: 12px; font-weight: 700; cursor: pointer; }\r\n.cfg-btn-edit  { background: none; border: none; cursor: pointer; font-size: 13px; opacity: 0.6; margin-right: 4px; }\r\n.cfg-btn-edit:hover { opacity: 1; }\r\n.cfg-btn-del   { background: none; border: none; color: #ef4444; font-size: 15px; font-weight: 700; cursor: pointer; padding: 0 4px; }\r\n.cfg-btn-del:hover { color: #b91c1c; }\r\n.cfg-err { color: #dc2626; font-size: 12px; margin-bottom: 8px; }\r\n\r\n/* ---- Import Excel ---- */\r\n.import-section {\r\n    margin-top: 28px;\r\n    padding: 20px;\r\n    background: #f8fafc;\r\n    border-radius: 8px;\r\n    border: 1px solid #e2e8f0;\r\n}\r\n\r\n.import-section h3 {\r\n    margin: 0 0 8px;\r\n    font-size: 15px;\r\n    font-weight: 700;\r\n    color: #1e293b;\r\n}\r\n\r\n.import-desc {\r\n    font-size: 13px;\r\n    color: #64748b;\r\n    margin: 0 0 16px;\r\n    line-height: 1.5;\r\n}\r\n\r\n.import-controls {\r\n    display: flex;\r\n    gap: 12px;\r\n    align-items: center;\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.import-file-input {\r\n    font-size: 13px;\r\n    color: #475569;\r\n}\r\n\r\n.import-error {\r\n    background: #fef2f2;\r\n    color: #dc2626;\r\n    padding: 8px 12px;\r\n    border-radius: 6px;\r\n    font-size: 13px;\r\n    margin-top: 8px;\r\n}\r\n\r\n.import-result {\r\n    margin-top: 12px;\r\n    background: #fff;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 6px;\r\n    padding: 14px;\r\n}\r\n\r\n.import-result-summary {\r\n    display: flex;\r\n    gap: 16px;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.import-ok { color: #16a34a; }\r\n.import-total { color: #64748b; font-weight: 400; }\r\n.import-warn { color: #d97706; }\r\n\r\n.import-estados-novos {\r\n    font-size: 13px;\r\n    color: #7c3aed;\r\n    background: #f5f3ff;\r\n    padding: 6px 10px;\r\n    border-radius: 4px;\r\n    margin: 8px 0;\r\n}\r\n\r\n.import-erros-list {\r\n    font-size: 12px;\r\n    color: #64748b;\r\n    margin-top: 8px;\r\n    max-height: 200px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.import-erros-list ul {\r\n    margin: 4px 0 0;\r\n    padding-left: 18px;\r\n}\r\n\r\n.import-erros-list li {\r\n    margin-bottom: 2px;\r\n}\r\n\r\n.import-ultima {\r\n    margin-top: 12px;\r\n    padding: 12px 14px;\r\n    background: #fff;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 6px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 16px;\r\n}\r\n\r\n.import-ultima-info {\r\n    font-size: 13px;\r\n    color: #475569;\r\n}\r\n\r\n.btn-danger {\r\n    padding: 7px 16px;\r\n    border: none;\r\n    border-radius: 6px;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    color: #fff;\r\n    background: #dc2626;\r\n    white-space: nowrap;\r\n    transition: background 0.15s;\r\n}\r\n\r\n.btn-danger:hover { background: #b91c1c; }\r\n.btn-danger:disabled { background: #fca5a5; cursor: not-allowed; }\r\n\r\n.import-gestores-novos {\r\n    font-size: 13px;\r\n    color: #0369a1;\r\n    background: #e0f2fe;\r\n    padding: 6px 10px;\r\n    border-radius: 4px;\r\n    margin: 8px 0;\r\n}\r\n\r\n.import-placeholders {\r\n    color: #6b7280;\r\n    font-weight: 400;\r\n    font-style: italic;\r\n}\r\n\r\n.import-revert-ok {\r\n    border-color: #bbf7d0;\r\n    background: #f0fdf4;\r\n}\r\n\r\n/* ============================================================\r\n   ANÁLISE COMERCIAL\r\n   ============================================================ */\r\n.analise-page { padding: 4px 0; }\r\n\r\n.analise-anos-selector {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    margin-bottom: 18px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.analise-selector-label {\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    color: #64748b;\r\n    margin-right: 4px;\r\n}\r\n\r\n.analise-ano-btn {\r\n    padding: 5px 14px;\r\n    border: 1.5px solid #cbd5e1;\r\n    border-radius: 20px;\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    color: #64748b;\r\n    background: #fff;\r\n    transition: all 0.15s;\r\n}\r\n.analise-ano-btn:hover { border-color: #94a3b8; color: #1e293b; }\r\n.analise-ano-btn.active { color: #fff; }\r\n\r\n/* KPIs */\r\n.analise-kpis {\r\n    display: flex;\r\n    gap: 14px;\r\n    margin-bottom: 20px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.analise-kpi-card {\r\n    flex: 1;\r\n    min-width: 240px;\r\n    background: #fff;\r\n    border: 1px solid #e2e8f0;\r\n    border-top: 3px solid #4f46e5;\r\n    border-radius: 8px;\r\n    padding: 14px 16px;\r\n}\r\n\r\n.analise-kpi-ano {\r\n    font-size: 13px;\r\n    font-weight: 700;\r\n    color: #64748b;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.analise-kpi-row {\r\n    display: flex;\r\n    gap: 16px;\r\n}\r\n\r\n.analise-kpi-item {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex: 1;\r\n}\r\n\r\n.analise-kpi-val {\r\n    font-size: 18px;\r\n    font-weight: 700;\r\n    color: #1e293b;\r\n    line-height: 1.2;\r\n}\r\n\r\n.analise-kpi-label {\r\n    font-size: 10px;\r\n    color: #94a3b8;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.4px;\r\n    margin-top: 2px;\r\n}\r\n\r\n/* Gráficos */\r\n.analise-charts-grid {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 16px;\r\n}\r\n\r\n.analise-chart-card {\r\n    background: #fff;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 8px;\r\n    padding: 16px;\r\n}\r\n\r\n.analise-chart-full {\r\n    grid-column: 1 / -1;\r\n}\r\n\r\n.analise-chart-card h4 {\r\n    margin: 0 0 12px;\r\n    font-size: 13px;\r\n    font-weight: 700;\r\n    color: #374151;\r\n}\r\n\r\n/* Tooltip */\r\n.analise-tooltip {\r\n    background: #1e293b;\r\n    border-radius: 6px;\r\n    padding: 8px 12px;\r\n    font-size: 12px;\r\n    color: #fff;\r\n    box-shadow: 0 4px 12px rgba(0,0,0,0.15);\r\n}\r\n\r\n.analise-tooltip-label {\r\n    font-weight: 700;\r\n    margin-bottom: 4px;\r\n    color: #94a3b8;\r\n    font-size: 11px;\r\n}\r\n\r\n/* ============================================================\r\n   FILTROS DE COLUNA (estilo Excel)\r\n   ============================================================ */\r\n.col-filter-wrap {\r\n    position: relative;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 2px;\r\n    cursor: pointer;\r\n    user-select: none;\r\n    white-space: nowrap;\r\n}\r\n\r\n.col-filter-btn {\r\n    background: none;\r\n    border: none;\r\n    padding: 2px 4px;\r\n    cursor: pointer;\r\n    border-radius: 3px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 3px;\r\n    font-size: 10.5px;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.4px;\r\n    color: #94a3b8;\r\n    transition: color 0.1s, background 0.1s;\r\n}\r\n.col-filter-btn:hover { color: #475569; background: #f1f5f9; }\r\n.col-filter-btn.filtered { color: #3182ce; }\r\n.col-filter-btn.sorted   { color: #7c3aed; }\r\n.col-filter-btn.filtered.sorted { color: #3182ce; }\r\n\r\n.col-filter-arrow {\r\n    font-size: 9px;\r\n    opacity: 0.7;\r\n}\r\n\r\n.col-filter-indicator {\r\n    font-size: 8px;\r\n    color: #3182ce;\r\n    font-weight: 900;\r\n}\r\n\r\n.col-filter-dropdown {\r\n    background: #fff;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 8px;\r\n    box-shadow: 0 8px 24px rgba(0,0,0,0.14);\r\n    padding: 8px 0;\r\n    min-width: 180px;\r\n    max-width: 260px;\r\n}\r\n\r\n.col-filter-sort {\r\n    display: flex;\r\n    gap: 4px;\r\n    padding: 4px 10px 8px;\r\n    border-bottom: 1px solid #f1f5f9;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.col-filter-sort-btn {\r\n    flex: 1;\r\n    background: #f8fafc;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 5px;\r\n    padding: 4px 8px;\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    color: #64748b;\r\n    cursor: pointer;\r\n    transition: all 0.1s;\r\n}\r\n.col-filter-sort-btn:hover { background: #e2e8f0; color: #1e293b; }\r\n.col-filter-sort-btn.active { background: #7c3aed; color: #fff; border-color: #7c3aed; }\r\n\r\n.col-filter-search {\r\n    width: calc(100% - 20px);\r\n    margin: 0 10px 6px;\r\n    padding: 5px 8px;\r\n    border: 1px solid #e2e8f0;\r\n    border-radius: 5px;\r\n    font-size: 12px;\r\n    outline: none;\r\n    box-sizing: border-box;\r\n}\r\n.col-filter-search:focus { border-color: #3182ce; }\r\n\r\n.col-filter-actions {\r\n    display: flex;\r\n    gap: 4px;\r\n    padding: 0 10px 6px;\r\n    border-bottom: 1px solid #f1f5f9;\r\n}\r\n\r\n.col-filter-action-btn {\r\n    font-size: 11px;\r\n    color: #3182ce;\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    padding: 2px 0;\r\n}\r\n.col-filter-action-btn:hover { text-decoration: underline; }\r\n\r\n.col-filter-list {\r\n    max-height: 200px;\r\n    overflow-y: auto;\r\n    padding: 2px 0;\r\n}\r\n\r\n.col-filter-item {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 7px;\r\n    padding: 4px 12px;\r\n    font-size: 12px;\r\n    color: #374151;\r\n    cursor: pointer;\r\n    transition: background 0.1s;\r\n}\r\n.col-filter-item:hover { background: #f0f4ff; }\r\n.col-filter-item input[type=\"checkbox\"] {\r\n    width: 13px;\r\n    height: 13px;\r\n    margin: 0;\r\n    cursor: pointer;\r\n    accent-color: #3182ce;\r\n}\r\n\r\n/* Coluna \"Fatura\" das Encomendas Fornecedor.\r\n   As etiquetas embrulham em vez de alargarem a coluna, porque há EFs\r\n   repartidas por 3 ou 4 faturas e alguns números têm 10 dígitos. */\r\n.orc-fat-cel {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 3px;\r\n    max-width: 130px;\r\n}\r\n.orc-fat-tag {\r\n    background: #dcfce7;\r\n    color: #15803d;\r\n    border-radius: 4px;\r\n    padding: 2px 6px;\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    white-space: nowrap;\r\n}\r\n.orc-fat-tag-generica { background: #fef3c7; color: #92400e; }\r\n.orc-fat-vazio { color: #94a3b8; font-size: 13px; }\r\n\r\n/* Notas dentro do filtro de coluna: \"a carregar\", \"sem valores\", ou o aviso de\r\n   que a lista de valores foi cortada. */\r\n.col-filter-nota {\r\n    padding: 6px 10px;\r\n    font-size: 0.75rem;\r\n    color: #64748b;\r\n    font-style: italic;\r\n}\r\n\r\n.ef-action { padding: 5px 10px; border: 1px solid; border-radius: 6px; background: none; cursor: pointer; font-size: 12px; font-weight: 600; }\r\n.ef-action-warning { border-color: #f59e0b; color: #b45309; }\r\n.ef-action-danger { border-color: #dc2626; color: #dc2626; }\r\n.ef-action-undo { padding: 5px 12px; border-color: #ef4444; color: #ef4444; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
